import { render, staticRenderFns } from "./PpvTrackFilter.vue?vue&type=template&id=2b589227&scoped=true"
import script from "./PpvTrackFilter.vue?vue&type=script&lang=js"
export * from "./PpvTrackFilter.vue?vue&type=script&lang=js"
import style0 from "./PpvTrackFilter.vue?vue&type=style&index=0&id=2b589227&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b589227",
  null
  
)

export default component.exports